import { render, staticRenderFns } from "./AppConfigSidebar.vue?vue&type=template&id=4f66aeee&"
import script from "./AppConfigSidebar.vue?vue&type=script&lang=js&"
export * from "./AppConfigSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports